import { all, fork, select } from 'redux-saga/effects'
import authSaga from './AuthSagas'
import contactButtonSaga from './ContactButtonSagas'
import settingsSaga from './SettingsSagas'
import shopifyProductSaga from './ShopifyProductSagas'
import appointmentSaga from './AppointmentSagas'
import calendlyEventSaga from './CalendlyEventSagas'
import bookingSaga from './BookingSagas'
import API from '../Services/Api'
import WebAPI from '../Services/WebApi'
import ShopifyAdminApi from '../Services/ShopifyAdminApi'
import CustomerPortalApi from '../Services/CustomerPortalApi'
import emailSettingsSaga from './EmailSettingsSagas'
import customerSaga from './CustomerSagas'
import teamSaga from './TeamSagas'
import workflowSaga from './WorkflowSagas'
import widgetSaga from './WidgetSagas'
import tagSaga from './TagSagas'
import waitlistSaga from './WaitlistSagas'
import { SettingsSelectors } from 'Redux/SettingsRedux'

/* ------------- API ------------- */

const api = API.create()
const webApi = WebAPI.create()
const sApi = ShopifyAdminApi.create()
const cApi = CustomerPortalApi.create()

/* ------------- Connect Types To Sagas ------------- */

export default function* root() {
  let serviceApi = window.isAppointoWeb ? webApi : api
  if (window.isShopifyAdmin) {
    serviceApi = sApi
  }
  if (window.customerPortal) {
    serviceApi = cApi
  }

  yield all([
    fork(authSaga, serviceApi),
    fork(contactButtonSaga, serviceApi),
    fork(settingsSaga, serviceApi),
    fork(shopifyProductSaga, serviceApi),
    fork(appointmentSaga, serviceApi),
    fork(bookingSaga, serviceApi),
    fork(calendlyEventSaga, serviceApi),
    fork(emailSettingsSaga, serviceApi),
    fork(customerSaga, serviceApi),
    fork(teamSaga, serviceApi),
    fork(workflowSaga, serviceApi),
    fork(tagSaga, serviceApi),
    fork(widgetSaga, serviceApi),
    fork(waitlistSaga, serviceApi),
  ])
}
